import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import moment from "moment";
import { useSelector } from "react-redux";

const ListDatatable = ({ id, myData, myClass }) => {
  const [data, setData] = useState();
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || [];

  useEffect(() => {
    setData(myData);
  }, [myData]);

  const columnDefs = [
    {
      name: "User Name",
      selector: (row) => row?.userId?.username,
      sortable: true,
    },
    {
      name: "Payment Intent Id",
      selector: (row) => row?.paymentIntentId,
      sortable: true,
      width: "225px",
    },
    {
      name: "Amount",
      selector: (row) => `€ ${row?.amount}`,
      sortable: true,
    },
    {
      name: "Currency",
      selector: (row) => row?.currency,
      sortable: true,
    },
    {
      name: "Transactions Status",
      selector: (row) => row?.status,
      sortable: true,
    },
    {
      name: "Date/Time",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
  ];

  let editRole = role?.some((r) =>
    ["suUsers", "superAdmin", "writeDeposits"].includes(r)
  );
  // console.log('loggg', editRole)

  useEffect(() => {
    const check = editRole;
    if (!check) {
      columnDefs.pop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnDefs]);

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

export default ListDatatable;
